import { type ReactNode } from 'react';
import App365Icon from '../ui/appsIcons/365';
import App365IconBranco from '../ui/appsIcons/365Branco';
import AutoMagicoIcon from '../ui/appsIcons/automagico';
import AutoMagicoIconBranco from '../ui/appsIcons/automagicoBranco';
import BotaoZapIcon from '../ui/appsIcons/BotaoZap';
import BotaoZapIconBranco from '../ui/appsIcons/BotaoZapBranco';
import CampoPersonalizadoIcon from '../ui/appsIcons/CampoPersonalizadoIcon';
import CampoPersonalizadoIconBranco from '../ui/appsIcons/CampoPersonalizadoIconBranco';
import ChegueiIcon from '../ui/appsIcons/ChegueiIcon';
import ChegueiIconBranco from '../ui/appsIcons/ChegueiIconBranco';
import DashIcon from '../ui/appsIcons/Dash';
import DashIconBranco from '../ui/appsIcons/DashIconBranco';
import DijitalIcon from '../ui/appsIcons/Dijital';
import DijitalIconBranco from '../ui/appsIcons/DijitalBranco';
import DropDigitalIcon from '../ui/appsIcons/DropDigitalIcon';
import DropDigitalIconBranco from '../ui/appsIcons/DropDigitalIconBranco';
import DropiIcon from '../ui/appsIcons/DropiIcon';
import DropiIconBranco from '../ui/appsIcons/DropiIconBranco';
import FreteHero from '../ui/appsIcons/FreteHero';
import FreteHeroBranco from '../ui/appsIcons/FreteHeroBranco';
import LilyIcon from '../ui/appsIcons/LilyIcon';
import LilyIconBranco from '../ui/appsIcons/LilyIconBranco';
import MelhorApp from '../ui/appsIcons/MelhorApp';
import MelhorAppBranco from '../ui/appsIcons/MelhorAppBranco';
import OvniIcon from '../ui/appsIcons/OvniIcon';
import OvniIconBranco from '../ui/appsIcons/OvniIconBranco';
import ParcelamentoIcon from '../ui/appsIcons/ParcelamentoIcon';
import ParcelamentoIconBranco from '../ui/appsIcons/ParcelamentoIconBranco';
import PromocaoAgendadaIcon from '../ui/appsIcons/PromocaoAgendadaIcon';
import PromocaoAgendadaIconBranco from '../ui/appsIcons/PromocaoAgendadaIconBranco';
import RastreioIcon from '../ui/appsIcons/RastreioIcon';
import RastreioIconBranco from '../ui/appsIcons/RastreioIconBranco';
import ReplayIcon from '../ui/appsIcons/ReplayIcon';
import ReplayIconBranco from '../ui/appsIcons/ReplayIconBranco';
import SakIcon from '../ui/appsIcons/SakIcon';
import SakIconBranco from '../ui/appsIcons/SakIconBranco';
import SellyIcon from '../ui/appsIcons/SellyIcon';
import SellyIconBranco from '../ui/appsIcons/SellyIconBranco';
import SuperCheckoutIcon from '../ui/appsIcons/SuperCheckout';
import SuperCheckoutIconBranco from '../ui/appsIcons/SuperCheckoutBranco';
import SuperFavoritoIcon from '../ui/appsIcons/SuperFavoritoIcon';
import SuperFavoritoIconBranco from '../ui/appsIcons/SuperFavoritoIconBranco';
import WhatslyIcon from '../ui/appsIcons/WhatslyIcon';
import WhatslyIconBranco from '../ui/appsIcons/WhatslyIconBranco';
import WidgetInstagramIcon from '../ui/appsIcons/WidgetInstagramIcon';
import WidgetInstagramIconBranco from '../ui/appsIcons/WidgetInstagramIconBranco';
import WidgetTikTokIcon from '../ui/appsIcons/WidgetTikTokIcon';
import WidgetTikTokIconBranco from '../ui/appsIcons/WidgetTikTokIconBranco';
import MontinkIcon from '../ui/appsIcons/Montink';
import DescricaoProIcon from '../ui/appsIcons/DescricaoProIcon';
import DescricaoProIconBranco from '../ui/appsIcons/DescricaoProIconBranco';
import Boss from '../ui/appsIcons/Boss';
import AreaDoCliente from '../ui/appsIcons/AreaDoCliente';
import AreaClienteBranco from '../ui/appsIcons/AreaClienteBranco';

export interface AppProps {
    app: {
        eplus: string;
        icon: ReactNode;
        name: string;
        content: ReactNode;
        integrations?: Integration;
        link?: string;
        hide?: boolean;
        suportLink?: string;
        slug: string;
    };
}

interface Integration {
    [key: string]: {
        show: boolean;
        img: string;
    };
}

export const EmpreenderApps = [
    {
        name: '365 Artes',
        eplus: '365ARTES',
        icon: <App365Icon />,
        iconwhite: <App365IconBranco />,
        tags: ['365artes', '365 artes', '365ARTES'],
        link: 'https://365artes.com.br',
        content: 'Um banco de artes para sua loja editáveis no Canva. Adicione selos nas fotos dos produtos',
        slug: '365artes',
        linkRating: 'https://www.nuvemshop.com.br/loja-aplicativos-nuvem/365artes/rating',
        genero: 'o',
        suportLink: 'https://suporte.com.br/365artes/',
        perguntasFrequentes: ['Banners ficam no Canva?', 'Adicionar selos no app?', 'Criar conta no 365Artes?'],
    },
    {
        name: 'Automágico',
        eplus: 'AUTOMAGICO',
        icon: <AutoMagicoIcon />,
        iconwhite: <AutoMagicoIconBranco />,
        tags: ['automagico', 'auto mágico', 'AUTOMAGICO'],
        link: 'https://automagico.com.br',
        content: 'Crie templates e cadastre produtos em massa a partir das fotos na sua loja',
        slug: 'automagico',
        genero: 'o',
        linkRating: 'https://www.nuvemshop.com.br/loja-aplicativos-nuvem/automagico-by-empreender/rating',
        suportLink: 'https://suporte.com.br/automagico/',
        perguntasFrequentes: ['Importar produtos em massa?', 'Garantir SKUs corretos?', 'Importar produtos pelo app?'],
    },
    {
        name: 'Área do cliente',
        eplus: 'AREACLIENTE',
        icon: <AreaDoCliente />,
        iconwhite: <AreaClienteBranco />,
        tags: ['area', 'cliente', 'Area do cliente'],
        link: 'https://app.areadocliente.com.br/',
        content: 'Personalize a experiência da sua Área do Cliente.',
        slug: 'areadocliente',
        genero: 'o',
        // linkRating: 'https://www.nuvemshop.com.br/loja-aplicativos-nuvem/replay/rating',
        suportLink: 'https://suporte.com.br/areaCliente/',
        // perguntasFrequentes: [
        // 	"Replay aumenta vendas?",
        // 	"Bolinhas interativas?",
        // 	"Cancelar assinatura?",
        // ],
    },
    {
        name: 'Frete Hero',
        eplus: 'FRETEHERO',
        icon: <FreteHero />,
        iconwhite: <FreteHeroBranco />,
        tags: ['frete hero', 'frete', 'FRETEHERO'],
        link: 'https://fretehero.com.br',
        content: 'Defina um prazo adicional de frete para produtos personalizados, sob encomenda e multi-CD',
        slug: 'fretehero',
        genero: 'o',
        linkRating: 'https://www.nuvemshop.com.br/loja-aplicativos-nuvem/frete-hero/rating',
        suportLink: 'https://suporte.com.br/frete-hero/',
        perguntasFrequentes: ['Configurar pré-venda?', 'Falar com o suporte?', 'Criar conta no app?'],
    },
    {
        name: 'Botão Zap',
        eplus: 'BOTAOZAP',
        icon: <BotaoZapIcon />,
        iconwhite: <BotaoZapIconBranco />,
        tags: ['botão zap', 'botaozap', 'zap'],
        link: 'https://empreender.plus/',
        content: 'Inicie o suporte com uma mensagem padrão que carrega o link do produto que seu cliente está interessado',
        slug: 'botaozap',
        genero: 'o',
        linkRating: 'https://www.nuvemshop.com.br/loja-aplicativos-nuvem/botao-zap/rating',
        suportLink: 'https://suporte.com.br/botao-zap/',
        perguntasFrequentes: ['Usar o Botão Zap?', 'Integrar à Shopify?', 'Valor do plano?'],
    },
    {
        name: 'Campo Personalizado',
        eplus: 'PERSONALIZADO',
        icon: <CampoPersonalizadoIcon />,
        iconwhite: <CampoPersonalizadoIconBranco />,
        tags: ['campo personalizado', 'campo', 'PERSONALIZADO'],
        link: 'https://campopersonalizado.com.br',
        content: 'Adicione campos extras aos seus produtos, como texto, arquivo ou seleção para produtos personalizados',
        slug: 'campopersonalizado',
        genero: 'o',
        linkRating: 'https://www.nuvemshop.com.br/loja-aplicativos-nuvem/campo-personalizado/rating',
        suportLink: 'https://suporte.com.br/campo-personalizado/',
        perguntasFrequentes: ['Adicionar campo personalizado?', 'Personalizar produto?', 'Campos invisíveis?'],
    },
    {
        name: 'Cheguei',
        eplus: 'CHEGUEI',
        icon: <ChegueiIcon />,
        iconwhite: <ChegueiIconBranco />,
        tags: ['cheguei', 'CHEGUEI'],
        link: 'https://cheguei.com.br',
        content: 'Salve clientes interessados em produtos esgotados e os avise quando essas mercadorias voltarem',
        slug: 'cheguei',
        genero: 'o',
        linkRating: 'https://www.nuvemshop.com.br/loja-aplicativos-nuvem/cheguei-avise-me/rating',
        suportLink: 'https://suporte.com.br/cheguei/',
        perguntasFrequentes: ['Instalar botão Avise-me?', 'Exportar relatórios?', 'Criar conta no Cheguei?'],
    },
    {
        name: 'Selly',
        eplus: 'BRINDE',
        icon: <SellyIcon />,
        iconwhite: <SellyIconBranco />,
        tags: ['Selly'],
        link: 'https://selly.com.br',
        content: 'Impulsione vendas com brindes no carrinho, timer, compre junto, favoritos e mais recursos.',
        slug: 'selly',
        genero: 'o',
        linkRating: 'https://www.nuvemshop.com.br/loja-aplicativos-nuvem/selly/rating',
        suportLink: 'https://suporte.com.br/selly/',
        perguntasFrequentes: ['Configurar Roleta no Selly?', 'Ativar ferramentas?', 'Ativar estoque na Nuvemshop?'],
    },
    {
        name: 'Dash Analytics',
        eplus: 'DASH',
        icon: <DashIcon />,
        iconwhite: <DashIconBranco />,
        tags: ['Dash', 'dashboard', 'dash'],
        link: 'https://app.dash.com.br/',
        content: 'Uma solução intuitiva e poderosa que centraliza informações de todos os seus aplicativos em um único lugar, permitindo uma visualização consolidada e personalizada dos dados mais relevantes para você',
        genero: 'o',
        slug: 'appdashboard',
        linkRating: 'https://www.nuvemshop.com.br/loja-aplicativos-nuvem/dash-board/rating',
        suportLink: 'https://suporte.com.br/dash/',
        perguntasFrequentes: ['O que é o Dash?', 'Como inserir gráficos?', 'Quais os planos e preços do Dash?'],
    },
    {
        name: 'Descrição Pro',
        eplus: 'DESCRICAOPRO',
        icon: <DescricaoProIcon />,
        iconwhite: <DescricaoProIconBranco />,
        tags: ['descrição pro', 'descricaopro', 'DESCRICAOPRO'],
        link: 'https://app..descricaopro.com.br',
        content: '',
        genero: 'o',
        slug: 'descricaopro',
        suportLink: 'https://suporte.com.br/descricaopro/',
        perguntasFrequentes: ['O que é o Descrição pro?'],
    },
    {
        name: 'Dijital',
        eplus: 'DIJITAL',
        icon: <DijitalIcon />,
        iconwhite: <DijitalIconBranco />,
        tags: ['dijital', 'digital', 'DIJITAL'],
        link: 'https://dijital.com.br',
        content: 'Venda e-books, PDFs, MP3, MP4 e todo tipo de infoproduto na sua loja virtual',
        slug: 'dijital',
        genero: 'o',
        linkRating: 'https://www.nuvemshop.com.br/loja-aplicativos-nuvem/dijital/rating',
        suportLink: 'https://suporte.com.br/dijital/',
        perguntasFrequentes: ['Desativar envio por e-mail?', 'Renovar assinatura (erro 401)?', 'Contatar suporte?'],
    },
    {
        name: 'Dropi',
        eplus: 'DROPI',
        icon: <DropiIcon />,
        iconwhite: <DropiIconBranco />,
        tags: ['dropi', 'DROPI'],
        link: 'https://dropi.com.br',
        content: 'Venda produtos do mundo todo sem estoque com dropshipping internacional e nacional',
        slug: 'dropi',
        genero: 'o',
        linkRating: 'https://www.nuvemshop.com.br/loja-aplicativos-nuvem/dropi/rating',
        suportLink: 'https://suporte.com.br/dropi/',
        perguntasFrequentes: ['Importar nacionais no plano grátis?', 'Filtrar por fornecedor?', 'Melhor plano inicial?'],
    },
    {
        name: 'Drop.Digital',
        eplus: 'DROPDIGITAL',
        icon: <DropDigitalIcon />,
        iconwhite: <DropDigitalIconBranco />,
        tags: ['drop.digital', 'dropdigital', 'drop digital', 'DROPDIGITAL'],
        link: 'https://dropdigital.com.br',
        content: 'Importe infoprodutos como cursos e ebooks do seu nicho e venda sem estoque na sua loja',
        slug: 'dropdigital',
        genero: 'o',
        linkRating: 'https://www.nuvemshop.com.br/loja-aplicativos-nuvem/drop-digital/rating',
        suportLink: 'https://suporte.com.br/dropdigital/',
        perguntasFrequentes: ['Vender cursos online?', 'Criar curso?', 'Qtd. de produtos?'],
    },
    {
        name: 'Plus',
        eplus: 'PLUS',
        icon: <Boss />,
        iconwhite: <Boss />,
        tags: ['empreender plus', 'EMPREENDERPLUS', 'Plus'],
        link: 'https://empreender.plus/',
        content: '+20 apps por R$297/mês. Economize até 60% e impulsione suas vendas!',
        slug: 'plus',
    },
    {
        name: 'Empreender Plus',
        eplus: 'PLUS',
        icon: <Boss />,
        iconwhite: <Boss />,
        tags: ['empreender plus', 'EMPREENDERPLUS'],
        link: 'https://empreender.plus/',
        content: '+20 apps por R$297/mês. Economize até 60% e impulsione suas vendas!',
        slug: 'plus',
    },

    {
        name: 'Landing Page',
        eplus: 'LANDINGPAGE',
        icon: <MelhorApp />,
        iconwhite: <MelhorAppBranco />,
        tags: ['landingpage', 'landing page', 'LANDINGPAGE'],
        link: 'https://landingpage.com.br/',
        content: 'Construa páginas web sem precisar de código. Escolha um modelo pronto ou comece do zero',
        slug: 'landingpage',
        genero: 'a',
        linkRating: 'https://www.nuvemshop.com.br/loja-aplicativos-nuvem/landing-page1/rating',
        suportLink: 'https://suporte.com.br/landing-page/',
        perguntasFrequentes: ['Criar página de vendas?', 'Hospedar páginas externas?', 'Vincular domínio?'],
    },
    {
        name: 'Lily Review',
        eplus: 'LILY',
        icon: <LilyIcon />,
        iconwhite: <LilyIconBranco />,
        tags: ['lily review', 'lily', 'lily reviews', 'LILY'],
        link: 'https://lily.com.br',
        content: 'Adicione avaliações em texto, foto ou vídeo, além de perguntas e respostas nos seus produtos',
        slug: 'lilyreviews',
        genero: 'o',
        linkRating: 'https://www.nuvemshop.com.br/loja-aplicativos-nuvem/lily-reviews/rating',
        suportLink: 'https://suporte.com.br/lily-reviews/',
        perguntasFrequentes: ['Importar avaliações do Ali?', 'Avaliações de produto descontinuado?', 'Personalizar e-mail?'],
    },
    {
        name: 'Ovni Influenciadores',
        eplus: 'OVNI2',
        icon: <OvniIcon />,
        iconwhite: <OvniIconBranco />,
        tags: ['ovni', 'OVNI'],
        link: 'https://ovni.com.br/',
        content: 'Crie campanhas e encontre o influenciador perfeito para seus produtos na rede social que preferir',
        slug: 'suporteovni',
        genero: 'o',
        linkRating: 'https://www.nuvemshop.com.br/loja-aplicativos-nuvem/ovni/rating',
        suportLink: 'https://suporte.com.br/ovni/',
        perguntasFrequentes: ['Criar campanha?', 'Encontrar influenciadores?', 'Cadastro como influenciador?'],
    },
    {
        name: 'Parcelamento',
        eplus: 'PARC',
        icon: <ParcelamentoIcon />,
        iconwhite: <ParcelamentoIconBranco />,
        tags: ['parcelamento', 'PARCELAMENTO'],
        link: 'https://parcelamento.com/',
        content: '',
        genero: 'o',
        slug: 'parcelamento',
        suportLink: 'https://suporte.com.br/parcelamento/',
        perguntasFrequentes: ['Como funciona o parcelamento?', 'Parcelamento afeta variantes?', 'Solicitar tema?'],
    },
    {
        name: 'Promoção agendada',
        eplus: 'PROMOAGENDADA',
        icon: <PromocaoAgendadaIcon />,
        iconwhite: <PromocaoAgendadaIconBranco />,
        tags: ['promoção agendada', 'promocao', 'PROMOAGENDADA'],
        link: 'https://empreender.plus',
        content: 'Programe alterações de preço em massa e aumente suas vendas em datas comemorativas',
        slug: 'promocaoagendada',
        genero: 'a',
        linkRating: 'https://www.nuvemshop.com.br/loja-aplicativos-nuvem/promocao-agendada/rating',
        suportLink: 'https://suporte.com.br/promocao-agendada/',
        perguntasFrequentes: ['Agendar promoção?', 'Contato com suporte?', 'Criar conta no app?'],
    },
    {
        name: 'Rastreio.net',
        eplus: 'RASTREIO',
        icon: <RastreioIcon />,
        iconwhite: <RastreioIconBranco />,
        tags: ['RASTREIO', 'rastreio'],
        link: 'https://get.rastreio.net',
        content: 'Página de rastreio de pacotes integrada às transportadoras e com envio de status por email',
        slug: 'rastreio',
        genero: 'o',
        linkRating: 'https://www.nuvemshop.com.br/loja-aplicativos-nuvem/rastreio-net/rating',
        suportLink: 'https://suporte.com.br/rastreio/',
        perguntasFrequentes: ['Adicionar logo nas mensagens?', 'Pedido não aparece?', 'Integrar à Yampi?'],
    },
    {
        name: 'Replay Video Commerce',
        eplus: 'REPLAY',
        icon: <ReplayIcon />,
        iconwhite: <ReplayIconBranco />,
        tags: ['replay', 'RP'],
        link: 'https://replay.com.br//',
        content: 'Adicione um vídeo flutuante à sua loja e mostre seus produtos na prática, oferecendo uma experiência visual envolvente',
        slug: 'replay',
        genero: 'o',
        linkRating: 'https://www.nuvemshop.com.br/loja-aplicativos-nuvem/replay/rating',
        suportLink: 'https://suporte.com.br/replay/',
        perguntasFrequentes: ['Replay aumenta vendas?', 'Bolinhas interativas?', 'Cancelar assinatura?'],
    },

    {
        name: 'Montink',
        eplus: 'REPLAY',
        icon: <MontinkIcon />,
        iconwhite: <MontinkIcon />,
        tags: ['montink'],
        link: 'https://montink.com/',
        content: 'Ganhe dinheiro vendendo produtos da sua marca sem precisar investir em estoque, produção ou logística.',
        slug: 'montink',
        genero: 'o',
        hide: true,
        linkRating: 'https://www.nuvemshop.com.br/loja-aplicativos-nuvem/replay/rating',
        suportLink: 'https://suporte.com.br/replay/',
        perguntasFrequentes: [],
    },
    {
        name: 'Sak',
        eplus: 'W',
        icon: <SakIcon />,
        iconwhite: <SakIconBranco />,
        tags: ['sak', 'suporte', 'atendimento', 'W'],
        link: 'https://get.sak.com.br',
        content: 'Recupere carrinhos, boletos e PIX com automações de WhatsApp. Crie artigos FAQs e atenda com IA',
        slug: 'suporte',
        genero: 'o',
        linkRating: 'https://www.nuvemshop.com.br/loja-aplicativos-nuvem/sak-recuperador-de-carrinhos-whatsapp/rating',
        suportLink: 'https://suporte.com.br/sak/',
        perguntasFrequentes: ['Acessar rascunhos?', 'Links estáticos contam cliques?', 'Mudar ícone do botão?'],
    },
    {
        name: 'Super Checkout',
        eplus: 'SUPERNUVEM',
        icon: <SuperCheckoutIcon />,
        iconwhite: <SuperCheckoutIconBranco />,
        tags: ['super checkout', 'checkout', 'SuperCheckout', 'SUPERNUVEM'],
        link: 'https://www.supercheckout.com.br/',
        content: 'Aumente a conversão com timer, recomendações de produtos, selos de autoridade e upsell no checkout.',
        slug: 'supercheckout',
        genero: 'o',
        linkRating: 'https://www.nuvemshop.com.1br/loja-aplicativos-nuvem/super-checkout/rating',
        suportLink: 'https://suporte.com.br/super-checkout/',
        perguntasFrequentes: ['Integrar à Nuvemshop', 'Adicionar selos', 'Usar cupom de trial'],
    },
    {
        name: 'Super Favoritos',
        eplus: 'SUPERFAV',
        icon: <SuperFavoritoIcon />,
        iconwhite: <SuperFavoritoIconBranco />,
        tags: ['super favorito', 'favorito', 'SUPERFAV', 'super favoritos'],
        link: 'https://empreender.plus/',
        content: 'Aumente suas vendas com lista de desejos e histórico de navegação na sua loja',
        genero: 'o',
        slug: 'superfavoritos',
        linkRating: 'https://www.nuvemshop.com.br/loja-aplicativos-nuvem/super-favoritos/rating',
        suportLink: 'https://suporte.com.br/super-favoritos/',
        perguntasFrequentes: ['Personalizar botão de favoritos?', 'Contato com suporte?', 'Adicionar cupom trial?'],
    },
    {
        name: 'Whats.ly',
        eplus: 'WHATSLY',
        icon: <WhatslyIcon />,
        iconwhite: <WhatslyIconBranco />,
        tags: ['WY', 'Whats.ly', 'WHATSLY'],
        link: 'https://get.whats.ly',
        content: 'Ideal para lançamentos de produtos de ecommerce, dropshipping, infoprodutos e qualquer estratégia de marketing digital',
        slug: 'whatsly',
        genero: 'o',
        linkRating: 'https://www.nuvemshop.com.br/loja-aplicativos-nuvem/whatsly/rating',
        suportLink: 'https://suporte.com.br/whatsly/',
        perguntasFrequentes: ['Integrar à Nuvemshop?', 'Assinar plano?', 'Adicionar membros?'],
    },
    {
        name: 'Widget Instagram',
        eplus: 'WIDGETINSTA',
        icon: <WidgetInstagramIcon />,
        iconwhite: <WidgetInstagramIconBranco />,
        tags: ['widget instagram', 'instagram', 'social', 'WIDGETINSTA'],
        link: 'https://widget.com.br',
        content: 'Adicione o feed do Instagram na sua loja. Marque produtos e leve o cliente para o checkout',
        slug: 'widget',
        genero: 'o',
        linkRating: 'https://www.nuvemshop.com.br/loja-aplicativos-nuvem/instagram-widget/rating',
        suportLink: 'https://suporte.com.br/widget-instagram/',
        perguntasFrequentes: ['Como faço para criar minha conta no Widget?'],
    },
    {
        name: 'Widget TikTok',
        eplus: 'WIDGETTIK',
        icon: <WidgetTikTokIcon />,
        iconwhite: <WidgetTikTokIconBranco />,
        tags: ['widget tiktok', 'tiktok', 'social', 'WIDGETTIK'],
        link: 'https://widget.com.br',
        content: 'Adicione vídeos do TikTok na sua loja. Marque produtos e leve o cliente para o checkout',
        genero: 'o',
        slug: 'widget-tiktok',
        suportLink: 'https://suporte.com.br/widget-tiktok/',
        perguntasFrequentes: ['Como faço para criar minha conta no Widget?'],
    },
];
